<div class="caProp">
  <span>CA Residents:</span>
  <a class="btn btn-light" href="../../../assets/docs/Kawneer_Prop_65_Product_Warning_Table.pdf"
     style="color:black;"
     target="_blank">
    Prop 65 Warning(s)
  </a>
</div>
